import styled from 'styled-components';

export const SelectDestination = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 40px;
  padding: 0 20px;
  margin-top: 35px;

  @media all and (max-width: 980px) {
    flex-wrap: nowrap;
    justify-content: flex-start;
    overflow-x: auto;
    gap: 25px;
    padding: 20px 16px 20px 16px;

    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none; /* IE e Edge */
    scrollbar-width: none; /* Firefox */
  }
`;

export const DestinationButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  transition: all 0.2s ease-in-out;
  width: 150px;

  img {
    width: 100%;
    height: 137px;
    object-fit: contain;
    border-radius: 12px;
    transition: all 0.2s ease-in-out;
  }

  span {
    font-weight: bold;
    color: #020c90;
    border: 1px solid #020c90;
    background-color: #f9f9f9;
    padding: 10px 5px;
    border-radius: 8px;
    width: 100%;
    text-align: center;
    transition: all 0.2s ease-in-out;
  }

  &:hover,
  &.selected {
    transform: translateY(-5px);

    img {
      box-shadow: 0 0 0 4px #ffcb29;
      padding: 5px;
    }

    span {
      background-color: #020c90;
      color: #fff;
    }
  }

  &.disabled {
    filter: grayscale(80%);
    opacity: 0.7;
    cursor: ponter;

    &:hover {
      transform: none;
      img {
        box-shadow: none;
      }
      span {
        background-color: #f9f9f9;
        color: #9a9a9a;
        border-color: #9a9a9a;
      }
    }
  }

  @media all and (max-width: 980px) {
    flex: 0 0 130px;
  }
`;
